


// const BASEURL = `http://localhost:5000/api/`;
// const BASEURL = `https://bmb-apis-uat.abym.us/api/`;
const BASEURL = `https://apis.bookmybeauty.in/api/`;


const API_URL = {
  BASEURL: BASEURL,
  // BASEURL2 : BASEURL2,
  refreshToken: 'v1/csrf/token',
  sessionToken: 'v1/csrf/sessiontoken',

  getDashboard: 'v1/admin/customer/dashaboard',
  getSettings: 'v1/admin/setting/list',
  settingDetails: 'v1/admin/setting',
  createSetting: 'v1/admin/setting/create',
  updateSetting: 'v1/admin/setting/update',
  deleteSetting: 'v1/admin/setting/delete',
  getCustomerReq: 'v1/admin/salon/list-new',
  updateServiceReq: 'v1/admin/salon/update/servicestatus',
  approvereq: 'v1/admin/salon/verify/customservice',
  serviceReqDetail: 'v1/admin/salon/list-details',

  getCategory: 'v1/category/list',
  deleteCategory: 'v1/category/deletecategory',
  updateCategory: 'v1/category/updatecategory',
  createCategory: 'v1/category/createcategory',
  createServices: 'v1/services/createservices',
  categoryDetail: 'v1/category/fetchcategory',

  updateServices: 'v1/services/updateservice',
  getServiceList: 'v1/services/list',
  getServiceByCategory: 'v1/services/listbycategory',
  // getServiceByCategory : 'v1/admin/salon/category/salonservicelist',
  serviceDetail: 'v1/services/servicedetail',


  getSlonlist: 'v1/admin/salon/list',
  getUpdatedSalons: 'v1/admin/salon/get/salon/updatelist',
  getSalonDetail: 'v1/admin/salon/salondetails',
  updateSalon: 'v1/admin/salon/updatesalon',
  updateSalonStatus: 'v1/admin/salon/update/status',
  getsalonCategory: 'v1/admin/salon/saloncategorylist',
  getSalonAppointment: 'v1/admin/salon/getall/appointments',
  getSalonCategoryServices: 'v1/admin/salon/category/salonservicelist',
  approveSalon: 'v1/admin/salon/verify/account',
  approveUpdateSalon: 'v1/admin/salon/verify/salon/update',
  approveUpdateImage: 'v1/admin/salon/verify/update/image',
  postRegister: 'v1/admin/salon/register',
  postSalonImage: 'v1/admin/salon/salonimage',
  postUserDelete: 'v1/user/delete',
  // postLoginStaff : 'https://hims.abymtech.com/new/abha-sdk/PatientsController/patientsvisitlist',

  getStaff: 'v1/admin/getstaff',
  getStaffDetails: 'v1/admin/getstaffdetail',
  logout: 'v1/admin/logout',
  postLoginStaff: 'v1/admin/login',
  postCreateStaff: 'v1/admin/createstaff',
  postUpdateStaff: 'v1/admin/updatestaff',
  postDeleteStaff: 'v1/admin//delete/staff',

  postCreateRole: 'v1/admin/createrole',
  postRoleCopy: 'v1/admin/getroles',
  postUpdateRole: 'v1/admin/updaterole',
  // postDeleteRole

  uploadImg: 'v1/upload/add',

  getNotification: 'v1/notification/notification',
  deleteNotification: 'v1/notification/notification-delete',
  updateNotification: 'v1/notification/notification-update',

  getBanner: 'v1/admin/banner/getAll',
  createBanner: 'v1/admin/banner/create',
  updateBanner: 'v1/admin/banner/update',
  bannerDetails: 'v1/admin/banner/get/detail',
  BannerPathidDetails: 'v1/admin/banner/get/list',
  bannerDelete: 'v1/admin/banner/delete',

  webGetBanner: 'v1/admin/website/banner/list',
  webCreateBanner: 'v1/admin/website/banner/create',
  webUpdateBanner: 'v1/admin/website/banner/update',
  webBannerDetails: 'v1/admin/website/banner/detail',
  webBannerPathidDetails: 'v1/admin/banner/get/list',
  webBannerDelete: 'v1/admin/website/banner/delete',
  webBannerStatus: 'v1/admin/website/banner/update-status',

  webGetService: 'v1/admin/website/common-services/list',
  webCreateService: 'v1/admin/website/common-services/create',
  webUpdateService: 'v1/admin/website/common-services/update',
  webServiceDetails: 'v1/admin/website/common-services/detail',
  webServiceDelete: 'v1/admin/website/common-services/delete',
  webServiceStatus: 'v1/admin/website/common-services/update-status',

  webGetContact: 'v1/admin/website/contact-details/list',
  webCreateContact: 'v1/admin/website/contact-details/create',
  webUpdateContact: 'v1/admin/website/contact-details/update',
  webContactDetails: 'v1/admin/website/contact-details/detail',
  webContactDelete: 'v1/admin/website/contact-details/delete',
  webContactStatus: 'v1/admin/website/contact-details/update-status',

  webGetEnquiry: 'v1/admin/website/enquiry/list',
  webEnquiryDelete: 'v1/admin/website/enquiry/delete',

  webGetTestimonial: 'v1/admin/website/testimonials/list',
  webCreateTestimonial: 'v1/admin/website/testimonials/create',
  webUpdateTestimonial: 'v1/admin/website/testimonials/update',
  webTestimonialDetails: 'v1/admin/website/testimonials/detail',
  webTestimonialDelete: 'v1/admin/website/testimonials/delete',
  webTestimonialStatus: 'v1/admin/website/testimonials/update-status',

  webGetAbout: 'v1/admin/website/about-us/list',
  webCreateAbout: 'v1/admin/website/about-us/create',
  webUpdateAbout: 'v1/admin/website/about-us/update',
  webAboutDetails: 'v1/admin/website/about-us/detail',
  webAboutDelete: 'v1/admin/website/about-us/delete',
  webAboutStatus: 'v1/admin/website/about-us/update-status',

  getVideo: 'v1/videos/video-list',
  deletevideo: 'v1/video/deletevideo',
  updatevideo: 'v1/videos/video-update',
  createVideo: 'v1/videos/video-add',
  videoDetail: 'v1/videos/video-detail',
  uploadThumbnail: 'v1/upload/add',

  getCustomerList: 'v1/admin/customer/list',
  getCustomerDetails: 'v1/admin/customer/customer-details',
  getTransactionList: 'v1/admin/rewardpoint/list',
  // customerRatingDelete:'v1/admin/customer/ratting-delete',
  statusUpdate: 'v1/admin/customer/update-status',
  uploadImg: 'v1/upload/add',

  getRole: 'v1/admin/getroles',
  createRole: 'v1/admin/createrole',
  updateRole: 'v1/admin/updaterole',
  roleDetail: 'v1/admin/getroles/details',
  moduleDetails: 'v1/admin/module/filterdata',
  createPermissionRole: 'v1/admin/add/permission',
  appointment: 'v1/admin/customer/appoiment-list',
  appointmentDetails: 'v1/admin/customer/appoiment-detail',

  createSalonUser: 'v1/admin/salon/register/salonuser',
  createSalon: 'v1/admin/salon/register/salon',
  saloonImageUpload: 'v1/admin/salon/images/upload',
  createSalonAddress: 'v1/admin/salon/register/salonaddress',
  getSalonServiceList: 'v1/admin/salon/salonservices',
  updatedImageList: 'v1/admin/salon/get/update/images',

  getRating: 'v1/admin/customer/ratting/list',
  postDeleteRating: 'v1/admin/customer/ratting/delete',
  postRatingStatusUpdate: 'v1/admin/customer/update/rating/status',
  coupons: 'v1/admin/coupon/getall',
  createCoupon: 'v1/admin/coupon/create',
  updateCoupon: 'v1/admin/coupon/update',
  couponDetails: 'v1/admin/coupon/getdetails',
  deleteCoupon: 'v1/admin/coupon/delete',
  updateCouponStatus: 'v1/admin/coupon/update/status',

  createOrUpdateAppVersion: 'v1/admin/app-version/create-or-update',
  appVersionList: 'v1/admin/app-version/list'
};
export default API_URL;
